import { registerPlugin } from '@capacitor/core';

import type { NetWorkPlugin } from './definitions';

const NetWork = registerPlugin<NetWorkPlugin>('NetWork', {
  web: () => import('./web').then(m => new m.NetWorkWeb()),
});

export * from './definitions';
export { NetWork };
